import { Component, OnInit, Inject } from '@angular/core';
import { SubjectService } from '../services/subject.service';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Account } from '../subject-insert/subject-insert.component';

@Component({
  selector: 'app-subject-account-modal',
  templateUrl: './subject-account-modal.component.html',
  styleUrls: ['./subject-account-modal.component.css']
})
export class SubjectAccountModalComponent implements OnInit {
  id:number;
  bank:string;
  bic:string;
  iban:string
  subject_id:number;
  currency:string;
  accounts:any;

  constructor( public dialogRef: MatDialogRef<SubjectAccountModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Account,private subjectService:SubjectService,
    private location: Location,
    private router: Router) { 

  }

  ngOnInit() {
  }

  closeModal() {
    this.dialogRef.close();

  }

  
}
